export default __webpack_public_path__ + "static/media/icon-edu-soft-round.83a7879c.svg";